/**
 * 英语单词词形还原器
 * 将单词的各种变形还原为原形，以便查找词典
 */

// 不规则动词表 - 过去式和过去分词到原形的映射
const irregularVerbs: Record<string, string> = {
  // 常见不规则动词
  'was': 'be', 'were': 'be', 'been': 'be', 'being': 'be',
  'had': 'have', 'has': 'have', 'having': 'have',
  'did': 'do', 'done': 'do', 'doing': 'do', 'does': 'do',
  'said': 'say', 'saying': 'say', 'says': 'say',
  'went': 'go', 'gone': 'go', 'going': 'go', 'goes': 'go',
  'got': 'get', 'gotten': 'get', 'getting': 'get', 'gets': 'get',
  'came': 'come', 'coming': 'come', 'comes': 'come',
  'saw': 'see', 'seen': 'see', 'seeing': 'see', 'sees': 'see',
  'took': 'take', 'taken': 'take', 'taking': 'take', 'takes': 'take',
  'made': 'make', 'making': 'make', 'makes': 'make',
  'knew': 'know', 'known': 'know', 'knowing': 'know', 'knows': 'know',
  'thought': 'think', 'thinking': 'think', 'thinks': 'think',
  'found': 'find', 'finding': 'find', 'finds': 'find',
  'gave': 'give', 'given': 'give', 'giving': 'give', 'gives': 'give',
  'told': 'tell', 'telling': 'tell', 'tells': 'tell',
  'became': 'become', 'becoming': 'become', 'becomes': 'become',
  'left': 'leave', 'leaving': 'leave', 'leaves': 'leave',
  'felt': 'feel', 'feeling': 'feel', 'feels': 'feel',
  'brought': 'bring', 'bringing': 'bring', 'brings': 'bring',
  'began': 'begin', 'begun': 'begin', 'beginning': 'begin', 'begins': 'begin',
  'kept': 'keep', 'keeping': 'keep', 'keeps': 'keep',
  'held': 'hold', 'holding': 'hold', 'holds': 'hold',
  'wrote': 'write', 'written': 'write', 'writing': 'write', 'writes': 'write',
  'stood': 'stand', 'standing': 'stand', 'stands': 'stand',
  'heard': 'hear', 'hearing': 'hear', 'hears': 'hear',
  'let': 'let', 'letting': 'let', 'lets': 'let',
  'meant': 'mean', 'meaning': 'mean', 'means': 'mean',
  'set': 'set', 'setting': 'set', 'sets': 'set',
  'met': 'meet', 'meeting': 'meet', 'meets': 'meet',
  'ran': 'run', 'running': 'run', 'runs': 'run',
  'moved': 'move', 'moving': 'move', 'moves': 'move',
  'lived': 'live', 'living': 'live', 'lives': 'live',
  'showed': 'show', 'shown': 'show', 'showing': 'show', 'shows': 'show',
  'asked': 'ask', 'asking': 'ask', 'asks': 'ask',
  'used': 'use', 'using': 'use', 'uses': 'use',
  'worked': 'work', 'working': 'work', 'works': 'work',
  'called': 'call', 'calling': 'call', 'calls': 'call',
  'tried': 'try', 'trying': 'try', 'tries': 'try',
  'studied': 'study', 'studying': 'study', 'studies': 'study',
  'needed': 'need', 'needing': 'need', 'needs': 'need',
  'seemed': 'seem', 'seeming': 'seem', 'seems': 'seem',
  'turned': 'turn', 'turning': 'turn', 'turns': 'turn',
  'started': 'start', 'starting': 'start', 'starts': 'start',
  'helped': 'help', 'helping': 'help', 'helps': 'help',
  'talked': 'talk', 'talking': 'talk', 'talks': 'talk',
  'put': 'put', 'putting': 'put', 'puts': 'put',
  'read': 'read', 'reading': 'read', 'reads': 'read',
  'cut': 'cut', 'cutting': 'cut', 'cuts': 'cut',
  'hit': 'hit', 'hitting': 'hit', 'hits': 'hit',
  'hurt': 'hurt', 'hurting': 'hurt', 'hurts': 'hurt',
  'cost': 'cost', 'costing': 'cost', 'costs': 'cost',
  'shut': 'shut', 'shutting': 'shut', 'shuts': 'shut',
  'spread': 'spread', 'spreading': 'spread', 'spreads': 'spread',
  'split': 'split', 'splitting': 'split', 'splits': 'split',
  'bet': 'bet', 'betting': 'bet', 'bets': 'bet',
  'burst': 'burst', 'bursting': 'burst', 'bursts': 'burst',
  'cast': 'cast', 'casting': 'cast', 'casts': 'cast',
  
  // 更多不规则动词
  'ate': 'eat', 'eaten': 'eat', 'eating': 'eat', 'eats': 'eat',
  'drank': 'drink', 'drunk': 'drink', 'drinking': 'drink', 'drinks': 'drink',
  'sang': 'sing', 'sung': 'sing', 'singing': 'sing', 'sings': 'sing',
  'rang': 'ring', 'rung': 'ring', 'ringing': 'ring', 'rings': 'ring',
  'swam': 'swim', 'swum': 'swim', 'swimming': 'swim', 'swims': 'swim',
  'flew': 'fly', 'flown': 'fly', 'flying': 'fly', 'flies': 'fly',
  'drew': 'draw', 'drawn': 'draw', 'drawing': 'draw', 'draws': 'draw',
  'grew': 'grow', 'grown': 'grow', 'growing': 'grow', 'grows': 'grow',
  'threw': 'throw', 'thrown': 'throw', 'throwing': 'throw', 'throws': 'throw',
  'blew': 'blow', 'blown': 'blow', 'blowing': 'blow', 'blows': 'blow',
  'broke': 'break', 'broken': 'break', 'breaking': 'break', 'breaks': 'break',
  'spoke': 'speak', 'spoken': 'speak', 'speaking': 'speak', 'speaks': 'speak',
  'chose': 'choose', 'chosen': 'choose', 'choosing': 'choose', 'chooses': 'choose',
  'froze': 'freeze', 'frozen': 'freeze', 'freezing': 'freeze', 'freezes': 'freeze',
  'stole': 'steal', 'stolen': 'steal', 'stealing': 'steal', 'steals': 'steal',
  'woke': 'wake', 'woken': 'wake', 'waking': 'wake', 'wakes': 'wake',
  'drove': 'drive', 'driven': 'drive', 'driving': 'drive', 'drives': 'drive',
  'rode': 'ride', 'ridden': 'ride', 'riding': 'ride', 'rides': 'ride',
  'rose': 'rise', 'risen': 'rise', 'rising': 'rise', 'rises': 'rise',
  'wore': 'wear', 'worn': 'wear', 'wearing': 'wear', 'wears': 'wear',
  'tore': 'tear', 'torn': 'tear', 'tearing': 'tear', 'tears': 'tear',
  'bore': 'bear', 'born': 'bear', 'borne': 'bear', 'bearing': 'bear', 'bears': 'bear',
  'swore': 'swear', 'sworn': 'swear', 'swearing': 'swear', 'swears': 'swear',
  'fell': 'fall', 'fallen': 'fall', 'falling': 'fall', 'falls': 'fall',
  'lay': 'lie', 'lain': 'lie', 'lying': 'lie', 'lies': 'lie',
  'paid': 'pay', 'paying': 'pay', 'pays': 'pay',
  'laid': 'lay', 'laying': 'lay', 'lays': 'lay',
  'sold': 'sell', 'selling': 'sell', 'sells': 'sell',
  'bought': 'buy', 'buying': 'buy', 'buys': 'buy',
  'caught': 'catch', 'catching': 'catch', 'catches': 'catch',
  'taught': 'teach', 'teaching': 'teach', 'teaches': 'teach',
  'fought': 'fight', 'fighting': 'fight', 'fights': 'fight',
  'sought': 'seek', 'seeking': 'seek', 'seeks': 'seek',
  'built': 'build', 'building': 'build', 'builds': 'build',
  'sent': 'send', 'sending': 'send', 'sends': 'send',
  'spent': 'spend', 'spending': 'spend', 'spends': 'spend',
  'lent': 'lend', 'lending': 'lend', 'lends': 'lend',
  'bent': 'bend', 'bending': 'bend', 'bends': 'bend',
  'lost': 'lose', 'losing': 'lose', 'loses': 'lose',
  'won': 'win', 'winning': 'win', 'wins': 'win',
  'shot': 'shoot', 'shooting': 'shoot', 'shoots': 'shoot',
  'led': 'lead', 'leading': 'lead', 'leads': 'lead',
  'fed': 'feed', 'feeding': 'feed', 'feeds': 'feed',
  'bled': 'bleed', 'bleeding': 'bleed', 'bleeds': 'bleed',
  'bred': 'breed', 'breeding': 'breed', 'breeds': 'breed',
  'fled': 'flee', 'fleeing': 'flee', 'flees': 'flee',
  'sped': 'speed', 'speeding': 'speed', 'speeds': 'speed',
  'slept': 'sleep', 'sleeping': 'sleep', 'sleeps': 'sleep',
  'swept': 'sweep', 'sweeping': 'sweep', 'sweeps': 'sweep',
  'wept': 'weep', 'weeping': 'weep', 'weeps': 'weep',
  'crept': 'creep', 'creeping': 'creep', 'creeps': 'creep',
  'leapt': 'leap', 'leaping': 'leap', 'leaps': 'leap',
  'dealt': 'deal', 'dealing': 'deal', 'deals': 'deal',
  'knelt': 'kneel', 'kneeling': 'kneel', 'kneels': 'kneel',
  'leant': 'lean', 'leaning': 'lean', 'leans': 'lean',
  'learnt': 'learn', 'learning': 'learn', 'learns': 'learn',
  'burnt': 'burn', 'burning': 'burn', 'burns': 'burn',
  'spilt': 'spill', 'spilling': 'spill', 'spills': 'spill',
  'spoilt': 'spoil', 'spoiling': 'spoil', 'spoils': 'spoil',
};

// 不规则复数名词
const irregularPlurals: Record<string, string> = {
  'children': 'child',
  'men': 'man',
  'women': 'woman',
  'people': 'person',
  'feet': 'foot',
  'teeth': 'tooth',
  'geese': 'goose',
  'mice': 'mouse',
  'dice': 'die',
  'lice': 'louse',
  'oxen': 'ox',
  'deer': 'deer',
  'fish': 'fish',
  'sheep': 'sheep',
  'series': 'series',
  'species': 'species',
  'aircraft': 'aircraft',
  'spacecraft': 'spacecraft',
  'means': 'means',
  'scissors': 'scissors',
  'glasses': 'glasses',
  'pants': 'pants',
  'shorts': 'shorts',
  'clothes': 'clothes',
  'thanks': 'thanks',
  'news': 'news',
  'physics': 'physics',
  'mathematics': 'mathematics',
  'economics': 'economics',
  'politics': 'politics',
  'athletics': 'athletics',
  'gymnastics': 'gymnastics',
  'electronics': 'electronics',
  'statistics': 'statistics',
  'dynamics': 'dynamics',
  'genetics': 'genetics',
  'linguistics': 'linguistics',
  'phonetics': 'phonetics',
  'acoustics': 'acoustics',
  'ethics': 'ethics',
  'classics': 'classics',
  'tactics': 'tactics',
  'mechanics': 'mechanics',
  'ceramics': 'ceramics',
  'graphics': 'graphics',
  'proceedings': 'proceedings',
  'earnings': 'earnings',
  'savings': 'savings',
  'surroundings': 'surroundings',
  'belongings': 'belongings',
  'contents': 'contents',
  'goods': 'goods',
  'premises': 'premises',
  'quarters': 'quarters',
  'headquarters': 'headquarters',
  'whereabouts': 'whereabouts',
  'archives': 'archives',
  'arms': 'arms',
  'customs': 'customs',
  'remains': 'remains',
  'stairs': 'stairs',
  'outskirts': 'outskirts',
  'riches': 'riches',
  'ashes': 'ashes',
  'congratulations': 'congratulations',
  'credentials': 'credentials',
  'finances': 'finances',
  'fireworks': 'fireworks',
  'furnishings': 'furnishings',
  'groceries': 'groceries',
  'leftovers': 'leftovers',
  'logistics': 'logistics',
  'manners': 'manners',
  'refreshments': 'refreshments',
  'regards': 'regards',
  'reservations': 'reservations',
  'resources': 'resources',
  'securities': 'securities',
  'specifications': 'specifications',
  'telecommunications': 'telecommunications',
  'utilities': 'utilities',
  'valuables': 'valuables',
  'wages': 'wages',
  // 更多不规则复数
  'criteria': 'criterion',
  'phenomena': 'phenomenon', 
  'alumni': 'alumnus',
  'analyses': 'analysis',
  'bases': 'basis',
  'crises': 'crisis',
  'diagnoses': 'diagnosis',
  'ellipses': 'ellipsis',
  'hypotheses': 'hypothesis',
  'oases': 'oasis',
  'parentheses': 'parenthesis',
  'syntheses': 'synthesis',
  'theses': 'thesis',
  'appendices': 'appendix',
  'indices': 'index',
  'matrices': 'matrix',
  'vertices': 'vertex',
  'formulae': 'formula',
  'antennae': 'antenna',
  'larvae': 'larva',
  'vertebrae': 'vertebra',
  'fungi': 'fungus',
  'nuclei': 'nucleus',
  'radii': 'radius',
  'stimuli': 'stimulus',
  'syllabi': 'syllabus',
  'termini': 'terminus',
  'bacteria': 'bacterium',
  'data': 'datum',
  'media': 'medium',
  'memoranda': 'memorandum',
  'strata': 'stratum',
  'addenda': 'addendum',
  'agenda': 'agendum',
  'curricula': 'curriculum',
  'millennia': 'millennium',
  'errata': 'erratum',
  // f/fe -> ves 复数
  'calves': 'calf',
  'halves': 'half',
  'knives': 'knife',
  'leaves': 'leaf',
  'lives': 'life',
  'loaves': 'loaf',
  'shelves': 'shelf',
  'thieves': 'thief',
  'wives': 'wife',
  'wolves': 'wolf',
  'elves': 'elf',
  'scarves': 'scarf',
  'dwarves': 'dwarf',
  // 其他复数形式
  'genitalia': 'genitalia',
  'paraphernalia': 'paraphernalia',
  'automata': 'automaton',
};

// 形容词比较级和最高级
const comparatives: Record<string, string> = {
  'better': 'good',
  'best': 'good',
  'worse': 'bad',
  'worst': 'bad',
  'more': 'much',
  'most': 'much',
  'less': 'little',
  'least': 'little',
  'further': 'far',
  'furthest': 'far',
  'farther': 'far',
  'farthest': 'far',
  'elder': 'old',
  'eldest': 'old',
  'older': 'old',
  'oldest': 'old',
  'bigger': 'big',
  'biggest': 'big',
  'smaller': 'small',
  'smallest': 'small',
  'larger': 'large',
  'largest': 'large',
  'longer': 'long',
  'longest': 'long',
  'shorter': 'short',
  'shortest': 'short',
  'higher': 'high',
  'highest': 'high',
  'lower': 'low',
  'lowest': 'low',
  'faster': 'fast',
  'fastest': 'fast',
  'slower': 'slow',
  'slowest': 'slow',
  'stronger': 'strong',
  'strongest': 'strong',
  'weaker': 'weak',
  'weakest': 'weak',
  'younger': 'young',
  'youngest': 'young',
  'newer': 'new',
  'newest': 'new',
  'cleaner': 'clean',
  'cleanest': 'clean',
  'darker': 'dark',
  'darkest': 'dark',
  'lighter': 'light',
  'lightest': 'light',
  'brighter': 'bright',
  'brightest': 'bright',
  'warmer': 'warm',
  'warmest': 'warm',
  'colder': 'cold',
  'coldest': 'cold',
  'harder': 'hard',
  'hardest': 'hard',
  'softer': 'soft',
  'softest': 'soft',
  'richer': 'rich',
  'richest': 'rich',
  'poorer': 'poor',
  'poorest': 'poor',
  'thicker': 'thick',
  'thickest': 'thick',
  'thinner': 'thin',
  'thinnest': 'thin',
  'wider': 'wide',
  'widest': 'wide',
  'narrower': 'narrow',
  'narrowest': 'narrow',
  'deeper': 'deep',
  'deepest': 'deep',
  'cheaper': 'cheap',
  'cheapest': 'cheap',
  'dearer': 'dear',
  'dearest': 'dear',
  'nearer': 'near',
  'nearest': 'near',
  'closer': 'close',
  'closest': 'close',
  'earlier': 'early',
  'earliest': 'early',
  'later': 'late',
  'latest': 'late',
  'easier': 'easy',
  'easiest': 'easy',
  'happier': 'happy',
  'happiest': 'happy',
  'sadder': 'sad',
  'saddest': 'sad',
  'angrier': 'angry',
  'angriest': 'angry',
  'busier': 'busy',
  'busiest': 'busy',
  'prettier': 'pretty',
  'prettiest': 'pretty',
  'uglier': 'ugly',
  'ugliest': 'ugly',
  'funnier': 'funny',
  'funniest': 'funny',
  'dirtier': 'dirty',
  'dirtiest': 'dirty',
  'emptier': 'empty',
  'emptiest': 'empty',
  'fuller': 'full',
  'fullest': 'full',
  'heavier': 'heavy',
  'heaviest': 'heavy',
};

/**
 * 词形还原器类
 */
export class WordLemmatizer {
  
  /**
   * 将单词还原为原形
   * @param word 要还原的单词
   * @returns 原形单词
   */
  lemmatize(word: string): string {
    const lowerWord = word.toLowerCase();
    
    // 1. 检查不规则动词
    if (irregularVerbs[lowerWord]) {
      return irregularVerbs[lowerWord];
    }
    
    // 2. 检查不规则复数
    if (irregularPlurals[lowerWord]) {
      return irregularPlurals[lowerWord];
    }
    
    // 3. 检查比较级和最高级
    if (comparatives[lowerWord]) {
      return comparatives[lowerWord];
    }
    
    // 4. 规则变形处理
    return this.handleRegularForms(lowerWord);
  }
  
  /**
   * 获取单词的所有可能原形（包括原词本身）
   * @param word 要查找的单词
   * @returns 所有可能的原形数组
   */
  getAllPossibleLemmas(word: string): string[] {
    const results = new Set<string>();
    const lowerWord = word.toLowerCase();
    
    // 添加原词
    results.add(lowerWord);
    
    // 添加还原后的词
    const lemma = this.lemmatize(lowerWord);
    if (lemma !== lowerWord) {
      results.add(lemma);
    }

    // 添加候选词形
    const candidateForms = this.generateCandidateBaseForms(lowerWord);
    candidateForms.forEach(form => results.add(form));

    // 对于某些特殊情况，尝试多种可能性
    const additionalForms = this.getAdditionalForms(lowerWord);
    additionalForms.forEach(form => results.add(form));
    
    return Array.from(results);
  }
  
  /**
   * 处理规则变形
   */
  private handleRegularForms(word: string): string {
    const candidates = this.generateCandidateBaseForms(word);
    return candidates.length > 0 ? candidates[0] : word;
  }

  /**
   * 根据常见的词形变化生成候选原形
   */
  private generateCandidateBaseForms(word: string): string[] {
    const candidates: string[] = [];
    const original = word.toLowerCase();

    const addCandidate = (form?: string | null, priority = false) => {
      if (!form) return;
      const normalized = form.toLowerCase();
      if (!normalized || normalized === original) return;
      if (!/^[a-z]+$/.test(normalized)) return;
      if (candidates.includes(normalized)) return;
      if (priority) {
        candidates.unshift(normalized);
      } else {
        candidates.push(normalized);
      }
    };

    // 处理 -ed 结尾
    if (original.endsWith('ed') && original.length > 2) {
      const stem = original.slice(0, -2);
      addCandidate(stem);
      addCandidate(stem.replace(/e$/, ''));
      if (original.length > 3) {
        const stem3 = original.slice(0, -3);
        addCandidate(stem3);
        if (stem.endsWith('ck')) {
          addCandidate(stem.slice(0, -1));
        }
        if (stem3.endsWith('ic')) {
          addCandidate(stem3, true);
        }
      }

      if (original.endsWith('ied') && original.length > 3) {
        addCandidate(original.slice(0, -3) + 'y', true);
      }

      if (original.length > 4 && original[original.length - 3] === original[original.length - 4] &&
          this.isConsonant(original[original.length - 3])) {
        addCandidate(original.slice(0, -3), true);
      }

      if (!stem.endsWith('e')) {
        addCandidate(stem + 'e', true);
      }
    }

    // 处理 -ing 结尾
    if (original.endsWith('ing') && original.length > 3) {
      const stem = original.slice(0, -3);
      addCandidate(stem);
      addCandidate(stem + 'e');
      if (stem.length > 0) {
        addCandidate(stem.slice(0, -1));
        if (stem.endsWith('ck')) {
          addCandidate(stem.slice(0, -1), true);
        }
      }

      if (original.length > 5 && original[original.length - 4] === original[original.length - 5] &&
          this.isConsonant(original[original.length - 4])) {
        addCandidate(original.slice(0, -4), true);
      }

      const ieRestores: Record<string, string> = {
        'lying': 'lie',
        'dying': 'die',
        'tying': 'tie',
        'vying': 'vie',
      };
      if (ieRestores[original]) {
        addCandidate(ieRestores[original], true);
      }
    }

    // 处理 -ies 结尾
    if (original.endsWith('ies') && original.length > 3) {
      addCandidate(original.slice(0, -3) + 'y', true);
      addCandidate(original.slice(0, -3) + 'ie');
    }

    // 处理 -ves 结尾
    if (original.endsWith('ves') && original.length > 3) {
      const base = original.slice(0, -3);
      addCandidate(base + 'f', true);
      addCandidate(base + 'fe', true);
      addCandidate(base + 've');
    }

    // 处理 -es 结尾
    if (original.endsWith('es') && !original.endsWith('ies') && !original.endsWith('ves')) {
      const base = original.slice(0, -2);
      addCandidate(base);
      addCandidate(base + 'e');

      if (base.endsWith('i') && base.length > 1) {
        addCandidate(base.slice(0, -1) + 'y', true);
      }
    }

    // 处理 -s 结尾
    if (original.endsWith('s') && original.length > 1 && !original.endsWith('ss')) {
      const nonPluralWords = new Set([
        'is', 'was', 'has', 'does', 'goes', 'this', 'yes', 'less', 'class',
        'glass', 'pass', 'bass', 'mass', 'grass', 'cross', 'boss', 'loss',
        'kiss', 'miss', 'discuss', 'focus', 'process', 'success', 'access',
        'address', 'express', 'progress', 'princess', 'business', 'witness',
        'fitness', 'illness', 'darkness', 'kindness', 'madness', 'sadness'
      ]);

      if (!nonPluralWords.has(original)) {
        const base = original.slice(0, -1);
        addCandidate(base);
        addCandidate(base + 'e');
      }
    }

    // 处理 -ly 结尾
    if (original.endsWith('ly') && original.length > 3) {
      const base = original.slice(0, -2);
      addCandidate(base);
      if (base.endsWith('i') && base.length > 1) {
        addCandidate(base.slice(0, -1) + 'y', true);
      }
      addCandidate(base + 'e');
    }

    // 处理 -er 结尾
    if (original.endsWith('er') && original.length > 3) {
      const base = original.slice(0, -2);
      addCandidate(base);
      addCandidate(base + 'e');

      if (base.length > 1 && base[base.length - 1] === base[base.length - 2] &&
          this.isConsonant(base[base.length - 1])) {
        addCandidate(base.slice(0, -1), true);
      }

      if (base.endsWith('i') && base.length > 1) {
        addCandidate(base.slice(0, -1) + 'y', true);
      }
    }

    // 处理 -est 结尾
    if (original.endsWith('est') && original.length > 4) {
      const base = original.slice(0, -3);
      addCandidate(base);
      addCandidate(base + 'e');

      if (base.length > 1 && base[base.length - 1] === base[base.length - 2] &&
          this.isConsonant(base[base.length - 1])) {
        addCandidate(base.slice(0, -1), true);
      }

      if (base.endsWith('i') && base.length > 1) {
        addCandidate(base.slice(0, -1) + 'y', true);
      }
    }

    return candidates;
  }
  
  /**
   * 获取额外的可能形式
   */
  private getAdditionalForms(word: string): string[] {
    const forms: string[] = [];
    
    // 对于以y结尾的词，尝试ies形式
    if (word.endsWith('ies') && word.length > 3) {
      forms.push(word.slice(0, -3) + 'y');
    }
    
    // 对于以ves结尾的词，尝试f/fe形式
    if (word.endsWith('ves') && word.length > 3) {
      const base = word.slice(0, -3);
      forms.push(base + 'f');
      forms.push(base + 'fe');
    }
    
    // 对于某些特殊复数形式
    if (word.endsWith('i') && word.length > 2) {
      forms.push(word.slice(0, -1) + 'us'); // alumni -> alumnus
    }
    
    if (word.endsWith('a') && word.length > 2) {
      forms.push(word.slice(0, -1) + 'um'); // data -> datum
    }
    
    return forms;
  }
  
  /**
   * 判断字符是否为辅音
   */
  private isConsonant(char: string): boolean {
    return Boolean(char && !'aeiou'.includes(char.toLowerCase()));
  }
  
  /**
   * 判断是否可能是以e结尾的动词
   */
  private isLikelyEEndingVerb(word: string): boolean {
    // 一些常见的以e结尾的动词模式
    const eEndingPatterns = [
      'make', 'take', 'come', 'give', 'live', 'love', 'move', 'leave', 'drive',
      'write', 'create', 'believe', 'receive', 'achieve', 'prepare', 'compare',
      'complete', 'include', 'continue', 'determine', 'provide', 'require',
      'suppose', 'imagine', 'examine', 'combine', 'describe', 'analyze',
      'organize', 'recognize', 'realize', 'exercise', 'practice', 'notice',
      'promise', 'surprise', 'welcome', 'excuse', 'refuse', 'confuse',
      'choose', 'lose', 'close', 'expose', 'compose', 'dispose', 'oppose',
      'interfere'
    ];
    
    // 检查是否匹配已知的e结尾动词
    if (eEndingPatterns.includes(word)) {
      return true;
    }
    
    // 检查一些模式
    if (word.endsWith('ise') || word.endsWith('ize') || word.endsWith('ate') || 
        word.endsWith('ive') || word.endsWith('ble') || word.endsWith('ple') ||
        word.endsWith('tle') || word.endsWith('nce') || word.endsWith('dge') ||
        word.endsWith('ose') || word.endsWith('use') || word.endsWith('ice')) {
      return true;
    }
    
    return false;
  }
}

// 创建全局实例
export const wordLemmatizer = new WordLemmatizer();

// 便捷函数
export function lemmatize(word: string): string {
  return wordLemmatizer.lemmatize(word);
}

export function getAllPossibleLemmas(word: string): string[] {
  return wordLemmatizer.getAllPossibleLemmas(word);
}
